import React, { Fragment } from 'react'

export default (props)=> {
  return props.children.split("\n").map((str, index) => <Fragment key={`${props.keyPrefix}-${index}`}>{str}<br /></Fragment>)
}